module.exports = __webpack_public_path__ + "static/img/8_1.f0dcb307.jpg";